
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as article_45archivedpoEPfydWuxMeta } from "/builds/synthese-et-medias/data-center-front/pages/archive/article-archived.vue?macro=true";
import { default as indexO1hJkZfXFUMeta } from "/builds/synthese-et-medias/data-center-front/pages/archive/press-review-archived/customer/[id]/index.vue?macro=true";
import { default as _91id_press_review_93E8exjMbvQ9Meta } from "/builds/synthese-et-medias/data-center-front/pages/archive/press-review-archived/customer/[id]/press-review/[id_press_review].vue?macro=true";
import { default as indexiBwQuivq52Meta } from "/builds/synthese-et-medias/data-center-front/pages/archive/press-review-archived/index.vue?macro=true";
import { default as createYo0mt6H5pWMeta } from "/builds/synthese-et-medias/data-center-front/pages/article/create.vue?macro=true";
import { default as forgot_45impersonateHNrtTj59WSMeta } from "/builds/synthese-et-medias/data-center-front/pages/forgot-impersonate.vue?macro=true";
import { default as forgot_45passwordr4Kt2CuNfYMeta } from "/builds/synthese-et-medias/data-center-front/pages/forgot-password.vue?macro=true";
import { default as indexbd57K53IEmMeta } from "/builds/synthese-et-medias/data-center-front/pages/index.vue?macro=true";
import { default as loginr9rc21NbYjMeta } from "/builds/synthese-et-medias/data-center-front/pages/login.vue?macro=true";
import { default as article_45adayGuubboAU82Meta } from "/builds/synthese-et-medias/data-center-front/pages/quick-access/article-aday.vue?macro=true";
import { default as article_45afpKqRdtvJL0aMeta } from "/builds/synthese-et-medias/data-center-front/pages/quick-access/article-afp.vue?macro=true";
import { default as article_45cfcZVaEj8ZcOaMeta } from "/builds/synthese-et-medias/data-center-front/pages/quick-access/article-cfc.vue?macro=true";
import { default as article_45opointeStkI9ZRsOMeta } from "/builds/synthese-et-medias/data-center-front/pages/quick-access/article-opoint.vue?macro=true";
import { default as article_45without_45cfcMOBZ7GcPFcMeta } from "/builds/synthese-et-medias/data-center-front/pages/quick-access/article-without-cfc.vue?macro=true";
import { default as indexvD7ul5rmECMeta } from "/builds/synthese-et-medias/data-center-front/pages/quick-access/press-review/customer/[id]/index.vue?macro=true";
import { default as _91id_press_review_93eGnr9YzyU3Meta } from "/builds/synthese-et-medias/data-center-front/pages/quick-access/press-review/customer/[id]/press-review/[id_press_review].vue?macro=true";
import { default as indexHrNONOpA64Meta } from "/builds/synthese-et-medias/data-center-front/pages/quick-access/press-review/index.vue?macro=true";
import { default as afpIcu19h7kkfMeta } from "/builds/synthese-et-medias/data-center-front/pages/search/afp.vue?macro=true";
import { default as opoint1IvrRZar6SMeta } from "/builds/synthese-et-medias/data-center-front/pages/search/opoint.vue?macro=true";
import { default as _91id_93PyJmECMV2ZMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/author/[id].vue?macro=true";
import { default as createdweYFtGSdYMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/author/create.vue?macro=true";
import { default as indexbVqt6mcXlAMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/author/index.vue?macro=true";
import { default as createWXNcU4pJfQMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-mailing-list/[id]/create.vue?macro=true";
import { default as _91id_mailing_93Vha9TC839BMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-mailing-list/[id]/edit/[id_mailing].vue?macro=true";
import { default as _91id_mailing_93atguqcm9a0Meta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-mailing-list/[id]/import/[id_mailing].vue?macro=true";
import { default as createE1l48xV583Meta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-mailing-list/[id]/recipient/[id_mailing]/create.vue?macro=true";
import { default as _91id_recipient_93rOdEsK8zglMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-mailing-list/[id]/recipient/[id_mailing]/edit/[id_recipient].vue?macro=true";
import { default as indexW9eUVUOjewMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-mailing-list/[id]/recipient/[id_mailing]/index.vue?macro=true";
import { default as createCJKLLT50oaMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-press-review-panorama-template/[id]/create.vue?macro=true";
import { default as _91id_panorama_93zZtHplqkzuMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-press-review-panorama-template/[id]/edit/[id_panorama].vue?macro=true";
import { default as _91id_93Z9KjRvzS8hMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-press-review-section/[id].vue?macro=true";
import { default as createqyqWr7mgtmMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-press-review-xml-config/[id]/create.vue?macro=true";
import { default as _91id_xml_config_93oDqUgoeBmhMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-press-review-xml-config/[id]/edit/[id_xml_config].vue?macro=true";
import { default as createzhaYss2MZUMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-press-review/[id]/create.vue?macro=true";
import { default as _91id_press_review_93uf4QJuN0E7Meta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-press-review/[id]/edit/[id_press_review].vue?macro=true";
import { default as createWmawXJccBRMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-user/[id]/create.vue?macro=true";
import { default as _91id_user_93VfvA7QAvLcMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer-user/[id]/edit/[id_user].vue?macro=true";
import { default as _91id_93L6DcOs1C3OMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer/[id].vue?macro=true";
import { default as createP5JbVfMeU2Meta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer/create.vue?macro=true";
import { default as indexD3d0sK3cKKMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/customer/index.vue?macro=true";
import { default as index5o1lUTUhVyMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/dropbox/index.vue?macro=true";
import { default as _91id_93YjCFqi50M5Meta } from "/builds/synthese-et-medias/data-center-front/pages/settings/financial-entity/[id].vue?macro=true";
import { default as createukmOogiQYNMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/financial-entity/create.vue?macro=true";
import { default as indexDGtBOExdiEMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/financial-entity/index.vue?macro=true";
import { default as _91id_931u8jPK6FuNMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/financial-index/[id].vue?macro=true";
import { default as createhG1eKzjCjbMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/financial-index/create.vue?macro=true";
import { default as indexf9aBhG2jXkMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/financial-index/index.vue?macro=true";
import { default as createpWc968ThrTMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/financial-indicator/[id]/create.vue?macro=true";
import { default as indexc6KYYH1oNHMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/financial-indicator/[id]/index.vue?macro=true";
import { default as _91name_93BQjXWE5N4bMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/ftp/[name].vue?macro=true";
import { default as createNRKxUW5xyeMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/ftp/create.vue?macro=true";
import { default as index3NKyMNQ08bMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/ftp/index.vue?macro=true";
import { default as innosys_45compare3pVO6EvHR8Meta } from "/builds/synthese-et-medias/data-center-front/pages/settings/innosys-compare.vue?macro=true";
import { default as indexdJSIxKlIC0Meta } from "/builds/synthese-et-medias/data-center-front/pages/settings/logs/index.vue?macro=true";
import { default as indexPXzvSy6Lm9Meta } from "/builds/synthese-et-medias/data-center-front/pages/settings/myrdp/user/index.vue?macro=true";
import { default as _91id_9354AdO7rgjLMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/source/[id].vue?macro=true";
import { default as create87yPoG5XWnMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/source/create.vue?macro=true";
import { default as importdSwuEaBon8Meta } from "/builds/synthese-et-medias/data-center-front/pages/settings/source/import.vue?macro=true";
import { default as indexnYVehNnDBMMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/source/index.vue?macro=true";
import { default as indexTgiZppHxV1Meta } from "/builds/synthese-et-medias/data-center-front/pages/settings/stats/index.vue?macro=true";
import { default as _91id_933Z1j9YoXZAMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/user/[id].vue?macro=true";
import { default as createzydLjZktINMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/user/create.vue?macro=true";
import { default as index64XQxsH0OKMeta } from "/builds/synthese-et-medias/data-center-front/pages/settings/user/index.vue?macro=true";
export default [
  {
    name: "archive-article-archived___fr",
    path: "/archive/article-archived",
    meta: article_45archivedpoEPfydWuxMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/archive/article-archived.vue")
  },
  {
    name: "archive-press-review-archived-customer-id___fr",
    path: "/archive/press-review-archived/customer/:id()",
    meta: indexO1hJkZfXFUMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/archive/press-review-archived/customer/[id]/index.vue")
  },
  {
    name: "archive-press-review-archived-customer-id-press-review-id_press_review___fr",
    path: "/archive/press-review-archived/customer/:id()/press-review/:id_press_review()",
    meta: _91id_press_review_93E8exjMbvQ9Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/archive/press-review-archived/customer/[id]/press-review/[id_press_review].vue")
  },
  {
    name: "archive-press-review-archived___fr",
    path: "/archive/press-review-archived",
    meta: indexiBwQuivq52Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/archive/press-review-archived/index.vue")
  },
  {
    name: "article-create___fr",
    path: "/article/create",
    meta: createYo0mt6H5pWMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/article/create.vue")
  },
  {
    name: "forgot-impersonate___fr",
    path: "/forgot-impersonate",
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/forgot-impersonate.vue")
  },
  {
    name: "forgot-password___fr",
    path: "/forgot-password",
    meta: forgot_45passwordr4Kt2CuNfYMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/forgot-password.vue")
  },
  {
    name: "index___fr",
    path: "/",
    meta: indexbd57K53IEmMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/index.vue")
  },
  {
    name: "login___fr",
    path: "/login",
    meta: loginr9rc21NbYjMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/login.vue")
  },
  {
    name: "quick-access-article-aday___fr",
    path: "/quick-access/article-aday",
    meta: article_45adayGuubboAU82Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/quick-access/article-aday.vue")
  },
  {
    name: "quick-access-article-afp___fr",
    path: "/quick-access/article-afp",
    meta: article_45afpKqRdtvJL0aMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/quick-access/article-afp.vue")
  },
  {
    name: "quick-access-article-cfc___fr",
    path: "/quick-access/article-cfc",
    meta: article_45cfcZVaEj8ZcOaMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/quick-access/article-cfc.vue")
  },
  {
    name: "quick-access-article-opoint___fr",
    path: "/quick-access/article-opoint",
    meta: article_45opointeStkI9ZRsOMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/quick-access/article-opoint.vue")
  },
  {
    name: "quick-access-article-without-cfc___fr",
    path: "/quick-access/article-without-cfc",
    meta: article_45without_45cfcMOBZ7GcPFcMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/quick-access/article-without-cfc.vue")
  },
  {
    name: "quick-access-press-review-customer-id___fr",
    path: "/quick-access/press-review/customer/:id()",
    meta: indexvD7ul5rmECMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/quick-access/press-review/customer/[id]/index.vue")
  },
  {
    name: "quick-access-press-review-customer-id-press-review-id_press_review___fr",
    path: "/quick-access/press-review/customer/:id()/press-review/:id_press_review()",
    meta: _91id_press_review_93eGnr9YzyU3Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/quick-access/press-review/customer/[id]/press-review/[id_press_review].vue")
  },
  {
    name: "quick-access-press-review___fr",
    path: "/quick-access/press-review",
    meta: indexHrNONOpA64Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/quick-access/press-review/index.vue")
  },
  {
    name: "search-afp___fr",
    path: "/search/afp",
    meta: afpIcu19h7kkfMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/search/afp.vue")
  },
  {
    name: "search-opoint___fr",
    path: "/search/opoint",
    meta: opoint1IvrRZar6SMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/search/opoint.vue")
  },
  {
    name: "settings-author-id___fr",
    path: "/settings/author/:id()",
    meta: _91id_93PyJmECMV2ZMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/author/[id].vue")
  },
  {
    name: "settings-author-create___fr",
    path: "/settings/author/create",
    meta: createdweYFtGSdYMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/author/create.vue")
  },
  {
    name: "settings-author___fr",
    path: "/settings/author",
    meta: indexbVqt6mcXlAMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/author/index.vue")
  },
  {
    name: "settings-customer-mailing-list-id-create___fr",
    path: "/settings/customer-mailing-list/:id()/create",
    meta: createWXNcU4pJfQMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-mailing-list/[id]/create.vue")
  },
  {
    name: "settings-customer-mailing-list-id-edit-id_mailing___fr",
    path: "/settings/customer-mailing-list/:id()/edit/:id_mailing()",
    meta: _91id_mailing_93Vha9TC839BMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-mailing-list/[id]/edit/[id_mailing].vue")
  },
  {
    name: "settings-customer-mailing-list-id-import-id_mailing___fr",
    path: "/settings/customer-mailing-list/:id()/import/:id_mailing()",
    meta: _91id_mailing_93atguqcm9a0Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-mailing-list/[id]/import/[id_mailing].vue")
  },
  {
    name: "settings-customer-mailing-list-id-recipient-id_mailing-create___fr",
    path: "/settings/customer-mailing-list/:id()/recipient/:id_mailing()/create",
    meta: createE1l48xV583Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-mailing-list/[id]/recipient/[id_mailing]/create.vue")
  },
  {
    name: "settings-customer-mailing-list-id-recipient-id_mailing-edit-id_recipient___fr",
    path: "/settings/customer-mailing-list/:id()/recipient/:id_mailing()/edit/:id_recipient()",
    meta: _91id_recipient_93rOdEsK8zglMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-mailing-list/[id]/recipient/[id_mailing]/edit/[id_recipient].vue")
  },
  {
    name: "settings-customer-mailing-list-id-recipient-id_mailing___fr",
    path: "/settings/customer-mailing-list/:id()/recipient/:id_mailing()",
    meta: indexW9eUVUOjewMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-mailing-list/[id]/recipient/[id_mailing]/index.vue")
  },
  {
    name: "settings-customer-press-review-panorama-template-id-create___fr",
    path: "/settings/customer-press-review-panorama-template/:id()/create",
    meta: createCJKLLT50oaMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-press-review-panorama-template/[id]/create.vue")
  },
  {
    name: "settings-customer-press-review-panorama-template-id-edit-id_panorama___fr",
    path: "/settings/customer-press-review-panorama-template/:id()/edit/:id_panorama()",
    meta: _91id_panorama_93zZtHplqkzuMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-press-review-panorama-template/[id]/edit/[id_panorama].vue")
  },
  {
    name: "settings-customer-press-review-section-id___fr",
    path: "/settings/customer-press-review-section/:id()",
    meta: _91id_93Z9KjRvzS8hMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-press-review-section/[id].vue")
  },
  {
    name: "settings-customer-press-review-xml-config-id-create___fr",
    path: "/settings/customer-press-review-xml-config/:id()/create",
    meta: createqyqWr7mgtmMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-press-review-xml-config/[id]/create.vue")
  },
  {
    name: "settings-customer-press-review-xml-config-id-edit-id_xml_config___fr",
    path: "/settings/customer-press-review-xml-config/:id()/edit/:id_xml_config()",
    meta: _91id_xml_config_93oDqUgoeBmhMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-press-review-xml-config/[id]/edit/[id_xml_config].vue")
  },
  {
    name: "settings-customer-press-review-id-create___fr",
    path: "/settings/customer-press-review/:id()/create",
    meta: createzhaYss2MZUMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-press-review/[id]/create.vue")
  },
  {
    name: "settings-customer-press-review-id-edit-id_press_review___fr",
    path: "/settings/customer-press-review/:id()/edit/:id_press_review()",
    meta: _91id_press_review_93uf4QJuN0E7Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-press-review/[id]/edit/[id_press_review].vue")
  },
  {
    name: "settings-customer-user-id-create___fr",
    path: "/settings/customer-user/:id()/create",
    meta: createWmawXJccBRMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-user/[id]/create.vue")
  },
  {
    name: "settings-customer-user-id-edit-id_user___fr",
    path: "/settings/customer-user/:id()/edit/:id_user()",
    meta: _91id_user_93VfvA7QAvLcMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer-user/[id]/edit/[id_user].vue")
  },
  {
    name: "settings-customer-id___fr",
    path: "/settings/customer/:id()",
    meta: _91id_93L6DcOs1C3OMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer/[id].vue")
  },
  {
    name: "settings-customer-create___fr",
    path: "/settings/customer/create",
    meta: createP5JbVfMeU2Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer/create.vue")
  },
  {
    name: "settings-customer___fr",
    path: "/settings/customer",
    meta: indexD3d0sK3cKKMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/customer/index.vue")
  },
  {
    name: "settings-dropbox___fr",
    path: "/settings/dropbox",
    meta: index5o1lUTUhVyMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/dropbox/index.vue")
  },
  {
    name: "settings-financial-entity-id___fr",
    path: "/settings/financial-entity/:id()",
    meta: _91id_93YjCFqi50M5Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/financial-entity/[id].vue")
  },
  {
    name: "settings-financial-entity-create___fr",
    path: "/settings/financial-entity/create",
    meta: createukmOogiQYNMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/financial-entity/create.vue")
  },
  {
    name: "settings-financial-entity___fr",
    path: "/settings/financial-entity",
    meta: indexDGtBOExdiEMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/financial-entity/index.vue")
  },
  {
    name: "settings-financial-index-id___fr",
    path: "/settings/financial-index/:id()",
    meta: _91id_931u8jPK6FuNMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/financial-index/[id].vue")
  },
  {
    name: "settings-financial-index-create___fr",
    path: "/settings/financial-index/create",
    meta: createhG1eKzjCjbMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/financial-index/create.vue")
  },
  {
    name: "settings-financial-index___fr",
    path: "/settings/financial-index",
    meta: indexf9aBhG2jXkMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/financial-index/index.vue")
  },
  {
    name: "settings-financial-indicator-id-create___fr",
    path: "/settings/financial-indicator/:id()/create",
    meta: createpWc968ThrTMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/financial-indicator/[id]/create.vue")
  },
  {
    name: "settings-financial-indicator-id___fr",
    path: "/settings/financial-indicator/:id()",
    meta: indexc6KYYH1oNHMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/financial-indicator/[id]/index.vue")
  },
  {
    name: "settings-ftp-name___fr",
    path: "/settings/ftp/:name()",
    meta: _91name_93BQjXWE5N4bMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/ftp/[name].vue")
  },
  {
    name: "settings-ftp-create___fr",
    path: "/settings/ftp/create",
    meta: createNRKxUW5xyeMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/ftp/create.vue")
  },
  {
    name: "settings-ftp___fr",
    path: "/settings/ftp",
    meta: index3NKyMNQ08bMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/ftp/index.vue")
  },
  {
    name: "settings-innosys-compare___fr",
    path: "/settings/innosys-compare",
    meta: innosys_45compare3pVO6EvHR8Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/innosys-compare.vue")
  },
  {
    name: "settings-logs___fr",
    path: "/settings/logs",
    meta: indexdJSIxKlIC0Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/logs/index.vue")
  },
  {
    name: "settings-myrdp-user___fr",
    path: "/settings/myrdp/user",
    meta: indexPXzvSy6Lm9Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/myrdp/user/index.vue")
  },
  {
    name: "settings-source-id___fr",
    path: "/settings/source/:id()",
    meta: _91id_9354AdO7rgjLMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/source/[id].vue")
  },
  {
    name: "settings-source-create___fr",
    path: "/settings/source/create",
    meta: create87yPoG5XWnMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/source/create.vue")
  },
  {
    name: "settings-source-import___fr",
    path: "/settings/source/import",
    meta: importdSwuEaBon8Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/source/import.vue")
  },
  {
    name: "settings-source___fr",
    path: "/settings/source",
    meta: indexnYVehNnDBMMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/source/index.vue")
  },
  {
    name: "settings-stats___fr",
    path: "/settings/stats",
    meta: indexTgiZppHxV1Meta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/stats/index.vue")
  },
  {
    name: "settings-user-id___fr",
    path: "/settings/user/:id()",
    meta: _91id_933Z1j9YoXZAMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/user/[id].vue")
  },
  {
    name: "settings-user-create___fr",
    path: "/settings/user/create",
    meta: createzydLjZktINMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/user/create.vue")
  },
  {
    name: "settings-user___fr",
    path: "/settings/user",
    meta: index64XQxsH0OKMeta || {},
    component: () => import("/builds/synthese-et-medias/data-center-front/pages/settings/user/index.vue")
  }
]